<template>
  <v-tooltip v-if="currentSource" :disabled="!hasTooltip" top content-class="construct-visual-image-tooltip">
    <template v-slot:activator="{ on, attrs }">
      <v-img
        v-bind="attrs"
        v-on="on"
        :src="currentSource"
        :alt="alt"
        :width="sizeValue(item.width)"
        :height="sizeValue(item.height)"
        :max-width="sizeValue(item.width)"
        :contain="item.fit === 'contain'"
        :class="imageClasses"
        :style="imageStyle"
        @error="useFallback"
      >
        <template v-slot:placeholder>
          <v-skeleton-loader type="image" :width="sizeValue(item.width)" :height="sizeValue(item.height)" />
        </template>
      </v-img>
    </template>
    <div class="construct-visual-image-tooltip__content">
      <v-img
        v-if="item.tooltipImage"
        :src="currentSource"
        :alt="alt"
        :width="tooltipWidth"
        :height="tooltipHeight"
        :max-width="tooltipWidth"
        contain
        class="construct-visual-image-tooltip__preview"
      />
      <div v-if="tooltipText" class="construct-visual-image-tooltip__text">{{ tooltipText }}</div>
    </div>
  </v-tooltip>
</template>

<script>
import displayMixin from './mixin'

export default {
  name: 'ConstructVisualDisplayImage',
  mixins: [displayMixin],
  data() { return { fallbackActive: false } },
  computed: {
    source() { return this.safeImageUrl(this.resolveValue(this.item.value, this.item.source)) },
    fallback() { return this.safeImageUrl(this.resolveTemplate(this.item.fallback)) },
    alt() { return this.resolveTemplate(this.item.alt) },
    borderColor() { return this.resolveTemplate(this.item.borderColor) },
    tooltipText() { return this.resolveTemplate(this.item.tooltipText) },
    hasTooltip() { return Boolean(this.item.tooltipImage || this.tooltipText) },
    tooltipWidth() { return this.sizeValue(this.resolveTemplate(this.item.tooltipWidth)) || 320 },
    tooltipHeight() { return this.sizeValue(this.resolveTemplate(this.item.tooltipHeight)) || 240 },
    currentSource() { return this.fallbackActive ? this.fallback : (this.source || this.fallback) },
    imageStyle() {
      return this.borderColor ? { border: `1px solid ${this.borderColor}` } : undefined
    },
    imageClasses() {
      return [this.item.class, {
        'rounded-lg': this.item.rounded && !this.item.circle,
        'rounded-circle': this.item.circle,
      }]
    },
  },
  watch: {
    source() { this.fallbackActive = false },
  },
  methods: {
    sizeValue(value) { return Number(value) || undefined },
    useFallback() {
      if (!this.fallbackActive && this.fallback) this.fallbackActive = true
    },
  },
}
</script>

<style>
.construct-visual-image-tooltip {
  background: rgba(33, 33, 33, 0.96) !important;
  padding: 8px !important;
}
.construct-visual-image-tooltip__content {
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: center;
}
.construct-visual-image-tooltip__preview {
  background: #fff;
  border-radius: 4px;
}
.construct-visual-image-tooltip__text {
  max-width: 320px;
  white-space: normal;
  text-align: center;
}
</style>
